import type { AuthUser } from '../context/AuthContext';

/**
 * Consent-pending: an authenticated user who has not accepted the current policies and is not
 * impersonating. Single source of truth for when the policies consent modal gates the app.
 */
export function isConsentPending(user: AuthUser | null | undefined): boolean {
  return !!user && !user.policiesAccepted && !user.isImpersonating;
}

/**
 * GDPR consent pending: policies accepted, not impersonating, and the person has never decided on
 * marketing consent — pending until they decide once. Mutually exclusive with isConsentPending.
 */
export function isGdprConsentPending(user: AuthUser | null | undefined): boolean {
  return !!user && user.policiesAccepted && !user.gdprConsentDecided && !user.isImpersonating;
}
